<main>
  <lib-feature-s-header
    [featureSHeader]="featureSHeaderConfig"
  ></lib-feature-s-header>
  <div class="n-container n-content">
    <router-outlet></router-outlet>
  </div>
  <lib-feature-s-navigate [items]="items"></lib-feature-s-navigate>
</main>

